<template>
  <div>
    <Header />
    <RouterView class="min-vh-100"/>
    <Footer />
  </div>
</template>

<script>
import Header from '@/components/Header'
import Footer from '@/components/Footer'

export default {
  components:{
    Header,
    Footer
  }
}
</script>
